import { Routes } from '@angular/router';
import { authGuard } from './core/auth.guard';
import { LoginComponent } from './pages/login.component';
import { LayoutComponent } from './layout/layout.component';
import { DashboardComponent } from './pages/dashboard.component';
import { MastersComponent } from './pages/masters.component';
import { StudentsComponent } from './pages/students.component';
import { GuestBookingComponent } from './pages/guest-booking.component';
import { SummerCampComponent } from './pages/summer-camp.component';
import { StaffManagementComponent } from './pages/staff-management.component';
import { ReportsComponent } from './pages/reports.component';
import { SettingsComponent } from './pages/settings.component';
import { GuestScanComponent } from './pages/guest-scan.component';
import { SimplePageComponent } from './pages/simple-page.component';
import { AttendanceComponent } from './pages/attendance.component';
import { FeesComponent } from './pages/fees.component';
import { QrComponent } from './pages/qr.component';
import { ProposalComponent } from './pages/proposal.component';

export const routes: Routes = [
  { path: 'proposal', component: ProposalComponent },
  { path: 'login', component: LoginComponent },
  { path: 'guest-scan/:cardNumber', component: GuestScanComponent },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [authGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
      { path: 'dashboard', component: DashboardComponent },
      { path: 'masters', component: MastersComponent },
      { path: 'students', component: StudentsComponent },
      { path: 'guest-booking', component: GuestBookingComponent },
      { path: 'summer-camp', component: SummerCampComponent },
      { path: 'monthly-enrollment', component: SimplePageComponent, data: { title: 'Monthly Enrollment' } },
      { path: 'staff', component: StaffManagementComponent },
      { path: 'attendance', component: AttendanceComponent },
      { path: 'fees', component: FeesComponent },
      { path: 'receipts', component: SimplePageComponent, data: { title: 'Receipts' } },
      { path: 'reports', component: ReportsComponent },
      { path: 'qr-cards', component: QrComponent },
      { path: 'settings', component: SettingsComponent }
    ]
  },
  { path: '**', redirectTo: 'dashboard' }
];
